import React, { useEffect } from "react";
import { useState } from "react";
import { isMobile } from "react-device-detect";
import { FaAngleDown, FaCheck } from "react-icons/fa";
import { Navbar } from "../../components/Navbar";
import { Sidebar } from "../../components/Sidebar";
import useApi from "../../hooks/useApi";
import apiClient, { initializeApiClient } from "../../api/apiClient";
import { toast } from "react-toastify";
export default () => {
  let initialState = {
    company_name: "",
    company_website: "",
    firstname: "",
    lastname: "",
    email: "",
    password: "",
    dob: "",
    shipping_address: "",
    phone_number: "",
  };
  const [installer, setInstaller] = useState(initialState);
  const [check, setCheck] = useState();
  const [showPassword, setShowPassword] = useState(true);
  const handleChange = (key, value) => {
    setInstaller({ ...installer, [key]: value });
  };
  const handleMobileInstaller = (value) => {
    if (check) {
      setCheck(!check);
    } else {
      setCheck(value);
    }
    setInstaller({ ...installer, mobile_installer: check });
  };
  const { request, loading, error } = useApi((installer) =>
    apiClient.put("/installerAccount", installer)
  );

  useEffect(() => {
    const fetch = async () => {
      initializeApiClient();
      const response = await apiClient.get("/installerAccount");
      const data = response.data;
      setInstaller(data);
      setCheck(data?.mobile_installer);
    };

    fetch();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await request(installer);
    if (!result.status === 200) {
      return toast.error("Error");
    } else {
      return toast.success("Account Successfully Created");
    }
  };

  // const [width, setWidth] = useState(window.innerWidth);

  // function handleWindowSizeChange() {
  //     setWidth(window.innerWidth);
  // }
  // useEffect(() => {
  //     window.addEventListener('resize', handleWindowSizeChange);
  //     return () => {
  //         window.removeEventListener('resize', handleWindowSizeChange);
  //     }
  // }, []);

  // const isMobile = width <= 768;
  return (
    <div className="site-content ">
      <form onSubmit={handleSubmit}>
        <div className="p-4">
          <div className="site-content-body">
            <div className="input-fields ">
              <div className="row gap-1 gap-md-2 justify-content-between">
                <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                  <label className="label blue-clr m-1" htmlFor="company-name">
                    Company Name
                  </label>
                  <input
                    type="text"
                    className="form-control m-1  px-2 py-1 fs-4"
                    id="company-name"
                    value={installer?.company_name}
                    onChange={(e) =>
                      handleChange("company_name", e.target.value)
                    }
                  />
                </div>

                <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                  <label
                    className="label blue-clr m-1"
                    htmlFor="company-Website"
                  >
                    Company Website
                  </label>
                  <input
                    type="text"
                    className="form-control m-1 px-2 py-1 fs-4"
                    id="company-Website"
                    value={installer?.company_website}
                    onChange={(e) =>
                      handleChange("company_website", e.target.value)
                    }
                  />
                </div>
              </div>

              <div className="row gap-1 gap-md-2 justify-content-between">
                <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                  <label className="label blue-clr m-1" htmlFor="First-name">
                    First Name
                  </label>
                  <input
                    type="text"
                    className="form-control m-1  px-2 py-1 fs-4"
                    id="First-name"
                    value={installer?.firstname}
                    onChange={(e) => handleChange("firstname", e.target.value)}
                  />
                </div>
                <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                  <label className="label blue-clr m-1" htmlFor="Last-name">
                    Last Name
                  </label>
                  <input
                    type="text"
                    className="form-control m-1  px-2 py-1 fs-4"
                    id="Last-name"
                    value={installer?.lastname}
                    onChange={(e) => handleChange("lastname", e.target.value)}
                  />
                </div>
              </div>

              <div className="row gap-1 gap-md-2 justify-content-between">
                <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                  <label className="label blue-clr m-1" htmlFor="Email">
                    Email
                  </label>
                  <input
                    type="email"
                    className="form-control m-1  px-2 py-1 fs-4"
                    id="Email"
                    value={installer?.email}
                    onChange={(e) => handleChange("email", e.target.value)}
                  />
                </div>

                <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                  <label className="label blue-clr m-1" htmlFor="Password">
                    Password
                  </label>
                  <div className="position-relative d-flex align-items-center ">
                    <input
                      type={showPassword ? "password" : "text"}
                      className="form-control m-1  px-2 py-1 pe-5 fs-4"
                      id="Password"
                      onChange={(e) => handleChange("password", e.target.value)}
                    />
                    <span
                      className="show-password"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? (
                        <i className="bi bi-eye-fill"></i>
                      ) : (
                        <i className="bi bi-eye-slash-fill"></i>
                      )}
                    </span>
                  </div>
                </div>
              </div>

              <div className="row gap-1 gap-md-2 justify-content-between">
                <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                  <label className="label blue-clr m-1" htmlFor="date-of-birth">
                    Date of Birth
                  </label>
                  <input
                    type="date"
                    className="form-control m-1  px-2 py-1 fs-4"
                    id="date-of-birth"
                    value={installer?.dob}
                    onChange={(e) => handleChange("dob", e.target.value)}
                  />
                </div>
                <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                  <label className="label blue-clr m-1" htmlFor="Phone-Number">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    className="form-control m-1  px-2 py-1 fs-4"
                    id="Phone-Number"
                    value={installer?.phone_number}
                    onChange={(e) =>
                      handleChange("phone_number", e.target.value)
                    }
                  />
                </div>
              </div>

              <div className="row gap-1 gap-md-2 justify-content-between">
                <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                  <label
                    className="label blue-clr m-1"
                    htmlFor="shipping-address"
                  >
                    Shipping Address
                  </label>
                  <input
                    type="text"
                    className="form-control m-1  px-2 py-1 fs-4"
                    id="shipping-address"
                    value={installer?.shipping_address}
                    onChange={(e) =>
                      handleChange("shipping_address", e.target.value)
                    }
                  />
                </div>

                <div className="col-md-5 d-flex flex-column mb-4 fs-5">
                  <label
                    className="label blue-clr m-1"
                    htmlFor="mobile-installer"
                  >
                    Mobile Installer (20 mile Radius)
                  </label>
                  <div className="d-flex flex-wrap installer">
                    <div className="d-flex align-items-center">
                      <input
                        // disabled={check === false}
                        checked={check === true}
                        type="checkbox"
                        id="yes"
                        className="form-check-input px-5 py-4 shadow-none m-1"
                        onChange={(e) => handleMobileInstaller(true)}
                      />
                      <label htmlFor="yes" className="blue-clr fs-4 ">
                        Yes
                      </label>
                    </div>
                    <div className="d-flex align-items-center">
                      <input
                        checked={check === false}
                        type="checkbox"
                        id="no"
                        className="form-check-input px-5 py-4 shadow-none m-1"
                        onChange={(e) => handleMobileInstaller(false)}
                      />
                      <label htmlFor="no" className="blue-clr fs-4">
                        No
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="select-applies d-flex flex-column align-items-center justify-content-center">
              <button
                type="submit"
                className="btn_bgnone save-changes blue-clr p-3 fs-4 border-0"
              >
                Save Changes <FaCheck />
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
